import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';

// Get all property listings
export const getPropertyListings = async (page = 1, pageSize = 10) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/property-listings`, {
            params: { page, pageSize }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get all rent properties
export const getRentListings = async (page = 1, pageSize = 100, fromDate = null, toDate = null, uniqueId = null, city = null) => {
    try {
        const params = { pageSize, page };
        
        // Add date parameters if provided
        if (fromDate) {
            params.fromDate = fromDate;
        }
        if (toDate) {
            params.toDate = toDate;
        }
        
        // Add filter parameters if provided
        if (uniqueId) {
            params.Unique_ID = uniqueId;
        }
        if (city) {
            params.City = city;
        }
        
        const response = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.RENT_PROPERTIES}`, {
            params
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching rent listings:', error);
        throw error;
    }
};

// Get all sell properties
export const getSellListings = async (page = 1, pageSize = 100, fromDate = null, toDate = null, uniqueId = null, city = null) => {
    try {
        const params = { pageSize, page };
        
        // Add date parameters if provided
        if (fromDate) {
            params.fromDate = fromDate;
        }
        if (toDate) {
            params.toDate = toDate;
        }
        
        // Add filter parameters if provided
        if (uniqueId) {
            params.Unique_ID = uniqueId;
        }
        if (city) {
            params.City = city;
        }
        
        const response = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SELL_PROPERTIES}`, {
            params
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching sell listings:', error);
        throw error;
    }
};

// Get all agriculture properties
export const getAgricultureListings = async (page = 1, pageSize = 100, fromDate = null, toDate = null, uniqueId = null, city = null) => {
    try {
        const params = { pageSize, page };
        
        // Add date parameters if provided
        if (fromDate) {
            params.fromDate = fromDate;
        }
        if (toDate) {
            params.toDate = toDate;
        }
        
        // Add filter parameters if provided
        if (uniqueId) {
            params.Unique_ID = uniqueId;
        }
        if (city) {
            params.City = city;
        }
        
        const response = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.AGRICULTURE_PROPERTIES}`, {
            params
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching agriculture listings:', error);
        throw error;
    }
};

// Get agriculture sell listings
export const getAgricultureSellListings = async (page = 1, pageSize = 10) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/property-listings/agriculture-sell`, {
            params: { page, pageSize }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get all joint venture properties
export const getJointVentureListings = async (page = 1, pageSize = 100, fromDate = null, toDate = null, uniqueId = null, city = null) => {
    try {
        const params = { pageSize, page };
        
        // Add date parameters if provided
        if (fromDate) {
            params.fromDate = fromDate;
        }
        if (toDate) {
            params.toDate = toDate;
        }
        
        // Add filter parameters if provided
        if (uniqueId) {
            params.Unique_ID = uniqueId;
        }
        if (city) {
            params.City = city;
        }
        
        const response = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.JOINT_VENTURE_PROPERTIES}`, {
            params
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching joint venture listings:', error);
        throw error;
    }
};

// Get investment listings
export const getInvestmentListings = async (page = 1, pageSize = 10, fromDate = null, toDate = null) => {
    try {
        const params = { page, pageSize };
        
        // Add date parameters if provided
        if (fromDate) {
            params.fromDate = fromDate;
        }
        if (toDate) {
            params.toDate = toDate;
        }
        
        const response = await axios.get(`${API_BASE_URL}/api/investor/getAll-investor`, {
            params
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}; 